/**
 * Browser-side preview for discount/cosmo-plan uploads. The fiscal-year label +
 * "as of …" snapshot tag are encoded in the FILENAME; the 9.3MB pivot workbook is
 * parsed entirely on the server. The preview only validates + reads the filename,
 * mirroring DiscountPlanFileParser.parse_filename (the server stays authoritative).
 */

export async function parseDiscountPlanForPreview(file: File): Promise<Record<string, unknown>> {
  const base = file.name
  const low = base.toLowerCase()

  if (!low.endsWith(".xlsx")) {
    throw new Error(`Format tidak didukung: "${base}". Cosmo plan hanya menerima .xlsx.`)
  }
  if (!low.includes("cosmo")) {
    throw new Error(`File Cosmo plan tidak dikenali dari nama: "${base}" (harus memuat "Cosmo").`)
  }

  let fiscalYearLabel = "FY2627"
  const fy = base.match(/fy\s?(\d{2})(\d{2})/i)
  if (fy) {
    fiscalYearLabel = `FY${fy[1]}${fy[2]}`
  } else {
    const years = (base.match(/\b(\d{2})\b/g) || [])
      .map((y) => parseInt(y, 10))
      .filter((y) => y >= 20 && y <= 40)
    if (years.length) {
      const y = Math.max(...years)
      fiscalYearLabel = `FY${String(y).padStart(2, "0")}${String((y + 1) % 100).padStart(2, "0")}`
    }
  }

  const stem = base.replace(/\.xlsx$/i, "")
  const m = stem.match(/(?:as of|up to)\s+(.+)$/i)
  const snapshotLabel = (m ? m[1] : stem).trim()

  return { fiscalYearLabel, snapshotLabel }
}
